<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      ref="logTable"
      v-if="showTable"
      :headers="headers"
      :get-data-func="getPassLogs"
      no-data-text="没有通行记录"
      clickable
      title-text="通行日志"
      :init-pagination="{sortBy: 'passDatetime', descending: true}"
      @click:row="goDetails"
      :filterItems="filterItems"
    >
      <template slot="title">
        <span class="pl-2 pr-4">车辆通行日志</span>
        <v-btn flat color="primary" @click="$router.push({name: 'VehiclePassStatistics'})">预约车辆统计</v-btn>
        <v-btn flat color="primary" :loading="exporting" @click="exportLogs">导出 Excel</v-btn>
        <v-btn flat color="primary" @click="showTable=!showTable">切换图表显示</v-btn>
      </template>
    </l-data-table>
    <v-layout v-else column>
      <iframe src="http://202.115.22.96:31678/app/kibana#/visualize/edit/714893f0-66bf-11ea-86f3-fb96ffc8987f?embed=true&_g=(refreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3Anow-120m%2Cto%3Anow))" height="600" width="800"></iframe>
    <!--  <v-flex xs4>
        <v-btn flat color="primary" @click="showTable=!showTable">切换表格显示</v-btn>
      </v-flex>
      <v-form class="pl-3">
        <v-layout>
          <v-flex xs5>
              <l-select-datetime-duration v-model="filterItems[1].value" label="通行时间"></l-select-datetime-duration>
          </v-flex>
          <v-btn flat color="primary" @click="drawCharts" :loading="loading">添加</v-btn>
        </v-layout>
      </v-form>
      <v-layout justify-center>
        <div id="myChart" :style="{width: '960px', height: '600px'}"></div>
      </v-layout>-->
    </v-layout>
  </l-layout>
</template>

<script>
import {time} from '../../../ladmin/utils'
import LSelectController from '../../../components/LSelectController'
import LSelectDatetimeDuration from '../../../ladmin/components/LSelectDuration/LSelectDatetimeDuration'

export default {
  name: 'PassLogList',
  components: {LSelectDatetimeDuration},
  data: () => ({
    showTable: true,
    loading: false,
    exporting: false,
    headers: [
      {text: '车辆号牌', value: 'plate', align: 'left', placeholder: 'N/A'},
      {text: '预约人', value: 'applicantName', align: 'left', placeholder: 'N/A', sortable: false},
      {text: '预约人二级单位', value: 'applicantOrgName', align: 'left', placeholder: 'N/A', sortable: false},
      {text: '个人/单位预约', value: 'passRuleType', align: 'left', sortable: false,
        f: v => v === 'order_object' ? '个人预约' : v === 'order_group' ? '单位预约' : 'N/A'},
      {text: '通行时间', value: 'passDatetime', align: 'right', placeholder: 'N/A'},
      {text: '停车场区', value: 'parkingLotName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '通行关口', value: 'controllerName', align: 'right', placeholder: 'N/A', sortable: false},
      {
        text: '是否放行',
        value: 'status',
        align: 'right',
        placeholder: 'N/A',
        f: v => v + '' === '1' ? '抬杆放行' : '禁止通行'
      },
      {text: '通行详情', value: 'details', align: 'right', placeholder: 'N/A', tooltip: true, maxWidth: '14em'}
    ],
    filterItems: [
      {
        label: '是否放行',
        layout: ['xs12', 'sm4'],
        type: 'select',
        key: 'status',
        value: '',
        items: [
          {text: '抬杆放行', value: '1'},
          {text: '禁止通行', value: '0'}
        ]
      },
      {
        label: '通行时间',
        layout: 'xs12, sm8',
        type: 'duration',
        key: 'passDatetime',
        value: {},
        range: true,
        f: v => {
          if (!v.startDatetime && !v.endDatetime) {
            return null
          }
          else {
            let s = v.startDatetime || '0000-01-01 00:00:00'
            let e = v.endDatetime || '9999-12-31 23:59:59'
            return [s, e]
          }
        }
      },
      {
        key: 'controllerId',
        value: [],
        component: LSelectController,
        f: v => {
          console.log([].concat(...v.map(g => g.controllers.map(c => c.id))))
          return [].concat(...v.map(g => g.controllers.map(c => c.id)))
        }
      }
    ],
    optionData: {
      color: ['#3398DB'],
      tooltip: {
        trigger: 'axis',
        axisPointer: { // 坐标轴指示器，坐标轴触发有效
          type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value'
      },
      series: [{
        name: '通行量',
        data: [],
        type: 'bar'
      }]
    },
    selectData: []
  }),
  methods: {
    async exportLogs () {
      const period = this.filterItems[1].value || {}
      const start = time.toTimeStamp(period.startDatetime)
      const end = time.toTimeStamp(period.endDatetime)
      if (!start || !end || end <= start || end - start > 93 * 24 * 60 * 60 * 1000) {
        this.$L.alert('error', {message: '请选择不超过93天的通行时间段'})
        return
      }
      this.exporting = true
      try {
        const table = this.$refs.logTable
        const items = []
        const size = 100
        for (let page = 1; ; page++) {
          const result = await this.$store.dispatch('pass/getLogs', {
            pagination: {page, rowsPerPage: size, sortBy: 'passDatetime', descending: true},
            filter: this.filterItems,
            search: {key: 'plate', value: table.search}
          })
          items.push(...result.items)
          if (page * size >= result.amount || !result.items.length) break
        }
        if (!items.length) {
          this.$L.alert('error', {message: '当前筛选条件下没有可导出的通行记录'})
          return
        }
        const ExportJsonExcel = require('js-export-excel')
        new ExportJsonExcel({
          fileName: '车辆通行日志',
          datas: [{
            sheetName: '通行日志',
            sheetHeader: ['车辆号牌', '预约人', '预约人二级单位', '个人/单位预约', '通行时间', '停车场区', '通行关口', '是否放行', '通行详情'],
            sheetData: items.map(item => [
              item.plate, item.applicantName, item.applicantOrgName,
              item.passRuleType === 'order_object' ? '个人预约' : item.passRuleType === 'order_group' ? '单位预约' : '',
              item.passDatetime, item.parkingLotName, item.controllerName,
              String(item.status) === '1' ? '抬杆放行' : '禁止通行', item.details
            ])
          }]
        }).saveExcel()
      }
      catch (error) {
        this.$L.alert('error', {message: '导出失败：' + error.message})
      }
      finally {
        this.exporting = false
      }
    },
    getPassLogs ({pagination, sortStack, filterItems, search}) {
      return this.$store.dispatch('pass/getLogs', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'plate', value: search}
      })
    },
    goDetails ({item}) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'VehicleStatisticDetails',
          params: {plate: item.plate},
          query: {id: item.id}
        })
      }
    },
    async drawCharts () {
      if (this.filterItems[1].value.startDatetime === undefined) {
        this.$L.alert('error', {message: '添加时间段不能为空'})
        return
      }
      // console.log(this.filterItems[1].value)
      this.loading = true
      let res = await this.$store.dispatch('pass/getLogs', {
        pagination: {},
        filter: this.filterItems,
      })
      this.loading = false
      this.optionData.xAxis.data.push(this.filterItems[1].value.startDatetime + '至' + this.filterItems[1].value.endDatetime)
      this.optionData.series[0].data.push(res.amount)
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption(this.optionData)
    }
  }
}
</script>

<style scoped>

</style>
